module.exports = __webpack_public_path__ + "img/default_bg.bec2017d.png";